// The ID, rather than the displayed label, identifies a selected mention.
export const parseMentionUri = uri => {
  if (uri === 'mention://all')
    return { mentionType: 'all', userId: '', userFullName: 'all' };
  const match = /^mention:\/\/(user|team)\/([1-9]\d*)\/(.+)$/.exec(uri);
  if (!match) return null;
  const [, mentionType, userId, encodedName] = match;
  try {
    return {
      mentionType,
      userId,
      userFullName: decodeURIComponent(encodedName),
    };
  } catch {
    return null;
  }
};
